<template>
  <div class="liquor-brewing">
    <Header active="/liquor/brewing" />
    <HeaderSelect :list="headerSelectArray" />

    <div class="head">
      <div class="title">葡萄酒酿造工艺</div>
      <div
        class="content"
      >酿造工艺是葡萄转变为葡萄酒过程中的点石成金术，远古时期人们就发现整束葡萄在不通气的罐中会发酵，发酵后的葡萄含有丝丝酒精味，芬芳醉人。随着科学的发展，发酵的奥秘得已揭露，人们开始利用发展出酿造工艺，弥补一些葡萄品种天然的缺陷，或是将原本优秀的葡萄品种加以调和平衡，发挥出葡萄酒更高雅馥郁的滋味。葡萄酒的酿造工艺总的来说可分为三个过程：原酒的发酵工艺、储藏管理工艺、灌装生产工艺。</div>
    </div>

    <div class="last last-1">
      <div class="left">
        <div class="title">如何挑选合适的葡萄品种？</div>
        <div
          class="content"
        >酿造葡萄酒与鲜食葡萄的品质是不同的。人们喜欢吃那些多汁、皮薄、籽少或无籽的葡萄。相反，人们一般用皮厚有籽的来酿酒，因为厚厚的果皮可以色泽和香气，葡萄籽则能够给红葡萄酒带来充足的单宁。根据类型或者品种的不同，葡萄果实在大小和特征方面会呈现出一定的差异性。即使是同一种的葡萄，因天气、土壤、种植者的技术水平等因素的不同会对葡萄产生一定影响。如果葡萄树的水份充足，果实就能够从中获取养分，从而长得饱满，果皮也相对较薄。反之，在干旱条件下，葡萄就长得更小，果皮较厚，厚厚的果皮里凝聚着葡萄酒的香气。</div>
      </div>
      <div class="right">
        <div class="top">著名红葡萄品种：</div>
        <div class="bottom">
          <div class="item">
            <img src="/liquor/赤霞珠  Cabernet Sauvignon.png" />
            <div class="cn">赤霞珠</div>
            <div class="en">Cabernet Sauvignon</div>
          </div>
          <div class="item">
            <img src="/liquor/梅乐  Merlot.png" />
            <div class="cn">梅乐</div>
            <div class="en">Merlot</div>
          </div>
          <div class="item">
            <img src="/liquor/西拉  Syrah.png" />
            <div class="cn">西拉</div>
            <div class="en">Syrah</div>
          </div>
          <div class="item">
            <img src="/liquor/黑品乐  Pinot Noir.png" />
            <div class="cn">黑皮诺</div>
            <div class="en">Pinot Noir</div>
          </div>
          <div class="item">
            <img src="/liquor/佳美  Gamay.png" />
            <div class="cn">佳美</div>
            <div class="en">Gamay</div>
          </div>
        </div>
        <div class="top">著名白葡萄品种：</div>
        <div class="bottom">
          <div class="item">
            <img src="/liquor/霞多丽  Chardonnay.png" />
            <div class="cn">霞多丽</div>
            <div class="en">Chardonnay</div>
          </div>
          <div class="item">
            <img src="/liquor/雷司令  Riesling.png" />
            <div class="cn">雷司令</div>
            <div class="en">Riesling</div>
          </div>
          <div class="item">
            <img src="/liquor/琼瑶浆  Traminer.png" />
            <div class="cn">琼瑶浆</div>
            <div class="en">Traminer</div>
          </div>
          <div class="item">
            <img src="/liquor/长相思  Sauvignon Blanc.png" />
            <div class="cn">长相思</div>
            <div class="en">Sauvignon Blanc</div>
          </div>
          <div class="item">
            <img src="/liquor/贵人香  Italian Riesling.png" />
            <div class="cn">贵人香</div>
            <div class="en">Italian Riesling</div>
          </div>
        </div>
      </div>
    </div>

    <div class="last last-2">
      <div class="left">
        <img src="/liquor/解百纳.png" />
      </div>
      <div class="right">
        <div class="title">我们常说的“解佰纳”是什么？</div>
        <div
          class="content"
        >“1931年，张裕酿酒师选用三种酿酒葡萄，酿造出一款全新的干红葡萄酒，取名为‘解百纳’ ”。 “解百纳”配方，是由赤霞珠酒液、蛇龙珠酒液、品丽珠酒液，按照一定的比例，混合调配的配方。</div>
      </div>
    </div>

    <div class="last last-3">
      <div class="title">白葡萄酒酿造工艺</div>
      <div class="content">白葡萄酒一般由白葡萄酿造，将果汁与果皮分离后，低温处理后再发酵，并在装瓶前要进行进行稳定行处理。</div>
      <div class="image">
        <img src="/liquor/白葡萄酿造工艺.png" />
      </div>
    </div>

    <div class="last last-4">
      <div class="title">红葡萄酒酿造工艺</div>
      <div class="content">与白葡萄酒酿造工艺不同的是：红葡萄酒是将皮与葡萄汁混合发酵的。这样可使葡萄中的色素和其他成份充分的被浸到果汁中，更好的展现酒的颜色和风味。</div>
      <div class="image">
        <img src="/liquor/红葡萄酒酿造工艺.png" />
      </div>
    </div>

    <Sticky />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import Sticky from "@/components/liquor/Sticky";
import HeaderSelect from "@/components/liquor/HeaderSelect";
import MultiMedia from "@/components/liquor/MultiMedia";

export default {
  name: "LiquorBrewing",
  components: {
    Header,
    Sticky,
    HeaderSelect,
    MultiMedia
  },
  data() {
    return {
      headerSelectArray: [
        {
          name: "分类体系",
          link: "/liquor/category",
          active: false
        },
        {
          name: "主力产区",
          link: "/liquor/country",
          active: false
        },
        {
          name: "酿造工艺",
          link: "/liquor/brewing",
          active: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.liquor-brewing {
  width: 100%;
  margin-top: 130px;
  padding-bottom: 100px;

  background: rgba(246, 237, 220, 1);

  .head {
    width: 100%;
    text-align: center;
    height: 320px;
    background: url("/liquor/酿造工艺背景图.png");

    .title {
      padding-top: 40px;
      font-size: 30px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
      line-height: 33px;
    }

    .content {
      width: 1000px;
      margin: 0 auto;
      padding-top: 35px;
      height: 120px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
    }
  }

  .last {
    width: 1100px;
    margin: 0 auto;
    background: white;

    .title {
      font-size: 26px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(194, 139, 43, 1);
      line-height: 28px;
    }

    .content {
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 30px;
    }

    .image {
      img {
        width: 100%;
      }
    }
  }

  .last-1 {
    margin-top: -50px;
    .left {
      vertical-align: top;
      display: inline-block;
      width: 440px;

      .title {
        padding: 40px 0 40px 40px;
      }

      .content {
        padding: 0 20px 40px 40px;
      }
    }

    .right {
      vertical-align: top;
      display: inline-block;
      width: 660px;
      background: #f4f4f4;
      padding-bottom: 20px;

      .top {
        height: 22px;
        font-size: 16px;

        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 22px;

        margin: 30px 0 20px 20px;
      }

      .bottom {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;

        .item {
          width: 116px;

          img {
            width: 116px;
          }
          div.cn {
            text-align: center;
            font-size: 12px;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 17px;
          }
          div.en {
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 17px;
            transform: scale(0.83);
          }
        }
      }
    }
  }

  .last-2 {
    margin-top: 20px;
    .left {
      vertical-align: top;
      display: inline-block;
      width: 440px;

      margin: 30px 80px;

      img {
        width: 100%;
      }
    }

    .right {
      vertical-align: top;
      display: inline-block;
      width: 400px;
      margin-left: 60px;

      .title {
        margin-top: 40px;
      }

      .content {
        margin-top: 40px;
      }
    }
  }

  .last-3 {
    width: 1020px;
    padding: 40px;
    margin-top: 20px;

    .content {
      margin-top: 40px;
      width: 545px;
    }
  }

  .last-4 {
    width: 1020px;
    padding: 40px;
    margin-top: 20px;
    // margin-top: 20px;

    .content {
      margin-top: 40px;
      width: 545px;
    }

    .image {
      margin-top: 40px;
    }
  }
}
</style>